import { mainTable } from "../css/Common";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import InputText from "../ReusableComponents/InputText";
import MultiSelect from "../ReusableComponents/MultiSelect";
import TextArea from "../ReusableComponents/TextArea";
import FileUpload from "../ReusableComponents/FileUpload";

const RoomTypeMasterPopup = ({ data, data1 }) => {
  return (
    <div class="w-full">
      <div>
        <div className={mainTable.mainContentScreen}>
          <form class="overflow-auto p-5 lg:h-96 md:min-h-[60vh] md:max-h-[60vh] min-h-fit max-h-fit sm:min-h-fit  sm:max-h-fit ">
            <div className={mainTable.grid3}>
              <InputText
                title="Room Type"
                inputType="text"
                name="RoomType"
                content={data.RoomType}
                classStar={"text-red-500"}
                placeholder="Room Type"
                // tabIndex="1"
                disabled={true}
                maxLength={50}
              />

              <InputText
                title="No of Rooms"
                inputType="text"
                name="noofrooms"
                content={data.NoOfRooms}
                classStar={"text-red-500"}
                placeholder="Room Type"
                // tabIndex="1"
                disabled={true}
                maxLength={50}
              />

              <InputText
                title="Size in Sq.ft"
                inputType="text"
                name="size"
                content={data.Size}
                classStar={"text-red-500"}
                placeholder="Size"
                // tabIndex="1"
                disabled={true}
                maxLength={50}
              />

              <InputText
                title="Maximum Occupancy"
                inputType="text"
                name="maximumOccpancy"
                content={data.MaxOccupancy}
                classStar={"text-red-500"}
                placeholder="Maximum Occupancy"
                // tabIndex="1"
                disabled={true}
                maxLength={50}
              />
               {data.Photo && (
                <div className="flex">
                  <div>
                    <img
                      src={data.Photo}
                      alt="Image"
                      className="rounded-none w-20 h-20"
                    />
                  </div>
                </div>
              )}
            </div>
            {/* {data1[3] && data1[3].length > 0 && (
              <div className="flex flex-wrap gap-4 mt-4">
                {data1[3].map((img, index) => (
                  <img
                    key={index}
                    src={img.photo} // instead of just img
                    alt={`RoomType ${index + 1}`}
                    className="w-40 h-40 object-cover rounded shadow"
                  />
                ))}
              </div>
            )} */}
               
            <TextArea
              title="Description"
              rows={3}
              name="Description"
              disabled={true}
              content={data.Description}
              placeholder="Description"
              // tabIndex="1"
              maxLength={500}
            />
          </form>
        </div>
      </div>
    </div>
  );
};
export default RoomTypeMasterPopup;
